import React from 'react'

function Aboutbreadcrumbs() {
  return (
    <div>
      <section className="breadcrumbs-custom-inset">
          <div className="breadcrumbs-custom context-dark bg-overlay-46">
            <div className="container">
              <h2 className="breadcrumbs-custom-title">About Our Company</h2>
              <ul className="breadcrumbs-custom-path">
                <li><a href="index.html">Home</a></li>
                <li className="active">About Us</li>
              </ul>
            </div>
            <div className="box-position" style={{backgroundImage:"url(assets/images/bannerabout1.png)"}}></div>
          </div>
        </section>
    </div>
  )
}

export default Aboutbreadcrumbs
